import React from 'react';
import { StarIcon, BadgeCheckIcon } from 'lucide-react';
const testimonials = [{
  initials: 'CG',
  name: 'Carmen Godoy',
  role: 'Docente',
  quote: 'Con este pack tengo todo listo para la semana en menos de 20 minutos. Mis clases cambiaron por completo.'
}, {
  initials: 'PG',
  name: 'Pedro Gutiérrez',
  role: 'Terapeuta',
  quote: 'Lo uso en mis sesiones y es un golazo. Actividades claras, visuales y listas para imprimir. Los chicos se enganchan enseguida y yo dejo de improvisar.'
}, {
  initials: 'JR',
  name: 'Julia Romero',
  role: 'Maestra de apoyo',
  quote: 'Por fin un material que sirve de verdad. Lenguaje, atención, motricidad… todo en un solo pack. Mis alumnos están más tranquilos y participan mucho más.'
}, {
  initials: 'MB',
  name: 'Martín Blanco',
  role: 'Papá',
  quote: 'Como papá lo recomiendo 100%. Lo que trae no tiene precio para todo lo que ahorrás en tiempo y energía.'
}, {
  initials: 'LF',
  name: 'Laura Fernández',
  role: 'Mamá y docente',
  quote: 'Las fichas de lenguaje son una belleza. Mis peques progresan rápido porque no se frustran. Todo está explicado de forma muy clara.'
}];
export function FullTestimonials() {
  return <section className="py-10 md:py-20 px-4 bg-white" data-id="element-125">
      <div className="max-w-4xl mx-auto" data-id="element-126">
        <h2 className="text-3xl md:text-4xl font-black text-center text-brand-dark mb-12" data-id="element-127">
          Lo que dicen quienes ya lo usan
        </h2>

        <div className="space-y-6" data-id="element-128">
          {testimonials.map((t, i) => <div key={i} className="bg-brand-gray p-6 md:p-8 rounded-2xl shadow-sm border border-gray-200" data-id="element-129">
              <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-130">
                <div className="flex-shrink-0 flex flex-col items-center" data-id="element-131">
                  <div className="w-14 h-14 bg-brand-blue text-white rounded-full flex items-center justify-center text-xl font-bold mb-2" data-id="element-132">
                    {t.initials}
                  </div>
                  <div className="flex text-yellow-400" data-id="element-133">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-134" />)}
                  </div>
                </div>
                <div data-id="element-135">
                  <p className="text-lg md:text-xl text-gray-800 leading-relaxed italic mb-4" data-id="element-136">
                    "{t.quote}"
                  </p>
                  <div className="flex items-center gap-3 flex-wrap" data-id="element-137">
                    <p className="font-bold text-brand-dark" data-id="element-138">
                      — {t.name},{' '}
                      <span className="text-gray-500 font-normal" data-id="element-139">
                        {t.role}
                      </span>
                    </p>
                    <span className="inline-flex items-center gap-1 bg-yellow-50 text-yellow-700 text-xs font-bold px-2.5 py-1 rounded-full border border-yellow-200" data-id="element-140">
                      <BadgeCheckIcon className="w-3.5 h-3.5 fill-yellow-400 text-yellow-700" data-id="element-141" />
                      Compra verificada
                    </span>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}